import { createStore, combineReducers } from "redux";

// import todoReducer from "./todoReducer";
import loginReducer from "./loginRs";
// import { homepageReducer } from "./homepageReducer";
import registerReducer from "./registerRs";
import movieReducer from "../../../../Redux/Reducer";

const rootReducer = combineReducers({
  // todo: todoReducer,
  register: registerReducer,
  login: loginReducer,
  movie: movieReducer,
  // homepage: homepageReducer,
});

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);
export default store;
